import { apiRequest } from '@/core';
import { type OrderCompetitionsPayload } from '@/slices/matches/types';

export const orderCompetitionsRequest = async (
  orderedCompetitions: OrderCompetitionsPayload,
) =>
  apiRequest<void>({
    endpoint: 'api/competitions/order',
    body: orderedCompetitions,
  });
